<template>
  <div class="hm-detail">
    <div class="hm-detail__left">
      <div class="hm-detail__item">
        <span class="hm-detail__label">Source:</span>
        <span class="hm-detail__value hm-detail__value--strong">
          {{ rData.source && rData.source.name }}
        </span>
        <template v-if="rData.external_id">
          <span class="hm-detail__sep">|</span>
          <span class="hm-detail__external">{{ rData.external_id }}</span>
        </template>
      </div>

      <div class="hm-detail__item">
        <span class="hm-detail__label">Meal plan:</span>
        <HMChip
          :color="rData.meal_plan.color"
          isMeal
        >
          {{ rData.meal_plan.name }}
        </HMChip>
        <span class="hm-detail__value hm-detail__value--strong">
          {{ rData.meal_plan && rData.meal_plan.full_name }}
        </span>
      </div>
    </div>

    <div v-if="rData.deadline && rData.deadline.date" class="hm-detail__right">
      <div class="hm-detail__label hm-detail__label--right">Deadline:</div>
      <div class="hm-detail__badge" :class="deadlineBadgeClass">
        {{ fmtDate(rData.deadline.date) }}
      </div>
    </div>
  </div>
</template>

<script>
import HMChip from '@/views/hotel-management/reservations/components/HMChip.vue'

export default {
  name: 'HMDetail',
  components: {HMChip},
  props: {
    rData: { type: Object, required: true },
  },
  computed: {
    deadlineBadgeClass() {
      const st = (
        this.rData.deadline && this.rData.deadline.status
      ) || 'ok'
      return `hm-detail__badge--${ st }`
    },
  },
  methods: {
    fmtDate(iso) {
      if (!iso) return ''
      const d = new Date(`${ iso }T00:00:00`)
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${ d.getDate() } ${ months[d.getMonth()] }, ${ d.getFullYear() }`
    },
  }
}
</script>

<style scoped>
.hm-detail {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid #EFF4F9;
  background: #FFF;
  margin-bottom: 30px;
}

.hm-detail__left, .hm-detail__right {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 24px 18px;
}

.hm-detail__left {
  flex: 1 1 auto;
  min-width: 0;
}

.hm-detail__right {
  position: relative;
  flex: 0 0 auto;
}

.hm-detail__right::before {
  content: '';
  position: absolute;
  left: 0;
  top: 20px;
  bottom: 18px;
  width: 1px;
  background-color: #EEF4FA;
}

.hm-detail__item {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.hm-detail__label {
  color: #8A8A8A;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.hm-detail__label--right {
  margin-right: 0;
}

.hm-detail__value {
  color: #000;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 15px;
}

.hm-detail__value--strong {
  font-weight: 600;
}

.hm-detail__external {
  color: #7c7c7c;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 16px;
  font-weight: 600;
}

.hm-detail__sep {
  color: #CFCFCF;
  margin: 0 8px;
}

.hm-detail__badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 6px;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 14px;
  font-weight: 500;
}

.hm-detail__badge--ok {
  color: #000;
  background: #F4F4F4;
}

.hm-detail__badge--expiring {
  color: #C28500;
  background: #FEF3D7;
}

.hm-detail__badge--expired {
  color: #C35B4E;
  background: #FFE8E6;
}
</style>
